import { useEffect, useState } from 'react';
import { getLocalePreference, subscribeLocaleChange } from '../utils/locale';

export default function useLocale() {
  const [locale, setLocale] = useState(() => getLocalePreference());

  useEffect(() => subscribeLocaleChange(setLocale), []);

  return locale;
}

